document.addEventListener('DOMContentLoaded', function() {
    const filterForms = document.querySelectorAll('.filter-bar');

    filterForms.forEach(form => {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            const topicSelect = this.querySelector('select#topic-select');
            const selectedValue = topicSelect ? topicSelect.value : '';

            // Update form action based on selection
			if (selectedValue) {
				this.action = `/learning-hub/category/${selectedValue}`;
			}

            // Submit the form
            this.submit();
        });
    });
});
